import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RequirePermission } from '../../features/auth/RequirePermission';
import { MembersPage } from '../../features/members/MembersPage';

// `member` opens that person's detail drawer over the list; same id shape as /members/$userId.
const search = z.object({
  member: z
    .string()
    .regex(/^[0-9a-f-]{36}$/i)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/members/')({
  validateSearch: search,
  component: () => (
    <RequirePermission permission="team.view">
      <MembersPage />
    </RequirePermission>
  ),
});
